enum SliceName {
  THEME = 'theme',
  READING_PREFERENCES = 'readingPreferences',
  QURAN_READER_STYLES = 'quranReaderStyles',
  TRANSLATIONS = 'translations',
  TAFSIRS = 'tafsirs',
  AUDIO_PLAYER_STATE = 'audioPlayerState',
  DEFAULT_SETTINGS = 'defaultSettings',
  BANNER = 'banner',
  NAVBAR = 'navbar',
  SESSION = 'session',
  BOOKMARKS = 'bookmarks',
  VOICE_SEARCH = 'voiceSearch',
  WELCOME_MESSAGE = 'welcomeMessage',
  COMMAND_BAR = 'commandBar',
  CONTEXT_MENU = 'contextMenu',
  FONT_FACES = 'fontFaces',
  NOTES = 'notes',
  READING_TRACKER = 'readingTracker',
  READING_VIEW_HOVERED_VERSE = 'readingViewHoveredVerse',
  SIDEBAR_NAVIGATION = 'sidebarNavigation',
  SEARCH = 'search',
  LOCALE = 'locale',
  USER_DATA_SYNC = 'userDataSync',
  PERSIST_GATE_HYDRATION = 'persistGateHydration',
  REVELATION_ORDER = 'revelationOrder',
  NOTIFICATIONS = 'notifications',
  ONBOARDING = 'onboarding',
  MEDIA_MAKER = 'mediaMaker',
}

export default SliceName;
